import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import style from './LoadingIndicator.module.scss';
import { connect } from 'react-redux';
import { AppState } from '../../../store';
import { SystemState } from '../../../store/system/types';
import { Col, Spin } from 'antd';
import { Bounce } from 'react-awesome-reveal';
import green from '../../images/Layout/greenwiselogo1.png';
import { LoadingOutlined } from '@ant-design/icons';
import expoFloresLoading from '../../images/Layout/loadingExpoflores.png'
interface LoadingIndicatorProps {
    system: SystemState;
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ system }) => {
    if (!system.showLoading) return <Fragment />;

    const tenant = process.env.REACT_APP_CODE_TENANT;

    return ReactDOM.createPortal(
        <div className={style['loading-indicator']}>
            <div className={style['center-container']}>
                <Col>
                    {tenant === 'EF' ? (
                        <div className={style['spin-container']}>
                            <img
                                loading="lazy"
                                src={expoFloresLoading}
                                alt="IconoExpoFlores"
                                className={style['spin-image']}
                            />
                        </div>) : (
                        <div className={style['bounce-container']}>
                            <Bounce>
                                <img src={green} alt="Green" />
                            </Bounce>
                        </div>
                    )}
                </Col>
            </div>
        </div>,
        document.body
    );
};

const mapStateToProps = (state: AppState) => ({
    system: state.system
});

export default connect(mapStateToProps)(LoadingIndicator);
